export default (date: Date, separator: string): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth()).padStart(2, '0');
  const year = date.getFullYear();
  return `${year}${separator}${month}${separator}${day}`;
};
